import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import { MemberState }      from "Utils/API";



// The initial State
const initialState = {
    loading   : false,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canFilter : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    sort      : {
        orderBy  : "stateCode",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "MEMBER_STATE_LOADING" });
    },

    /**
     * Fetches the Member State List
     * @param {Function} dispatch
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, params = {}) {
        const data = await MemberState.getAll(params);
        data.sort  = params;
        dispatch({ type : "MEMBER_STATE_LIST", data });
    },

    /**
     * Fetches a single Member State
     * @param {Function} dispatch
     * @param {Number}   stateCode
     * @returns {Promise}
     */
    async fetchElem(dispatch, stateCode) {
        const data = await MemberState.getOne({ stateCode });
        dispatch({ type : "MEMBER_STATE_ELEM", data });
    },

    /**
     * Edits/Creates a Member State
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return MemberState.edit(data);
    },

    /**
     * Deletes a Member State
     * @param {Function} dispatch
     * @param {Number}   stateCode
     * @returns {Promise}
     */
    deleteElem(dispatch, stateCode) {
        return MemberState.delete({ stateCode });
    },
};



/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.allowsAccessText = Utils.toYesNo(elem.allowsAccess);
    return elem;
}

/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "MEMBER_STATE_LIST", "MEMBER_STATE_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "MEMBER_STATE_LOADING":
        return {
            ...state,
            loading   : true,
        };

    case "MEMBER_STATE_LIST":
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canFilter : action.data.canFilter,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : Utils.parseList(action.data.list, parseElem),
            total     : action.data.total,
            sort      : action.data.sort,
        };

    case "MEMBER_STATE_ELEM":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            elem      : parseElem(action.data.elem),
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
